import * as StocktakingApi from "../../api/stocktakingApi";
import {
  REQUEST_AWAITING_STOCKTAKING_COUNTS,
  REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS,
  StocktakingActionTypes
} from "./types";
import {
  AwaitingStocktakingCounts,
  StoreStocktakingItem
} from "../../models/Stocktaking";
import { isOk, Result } from "../../result";
import { ProblemDetails } from "../../models/Http";

function fetchAwaitingStoreStocktakingItems(
  result: Result<ProblemDetails, ReadonlyArray<StoreStocktakingItem>>
): StocktakingActionTypes {
  return {
    type: REQUEST_AWAITING_STORE_STOCKTAKING_ITEMS,
    payload: result
  };
}

function fetchAwaitingStoreStocktakingCounts(
  payload: Result<ProblemDetails, AwaitingStocktakingCounts>
): StocktakingActionTypes {
  return {
    type: REQUEST_AWAITING_STOCKTAKING_COUNTS,
    payload: payload
  };
}

export const thunkFetchAwaitingStocktakingItemsByStore = (
  storeId: string
) => async (dispatch: any) => {
  const result = await StocktakingApi.listAwaitingByStore(storeId);

  if (!isOk(result)) {
    console.error(result.details);
  }

  dispatch(fetchAwaitingStoreStocktakingItems(result));
};

export const thunkFetchAwaitingStocktakingItems = () => async (
  dispatch: any
) => {
  const result = await StocktakingApi.listAwaitingInStores();

  if (!isOk(result)) {
    console.error(result.details);
  }
  dispatch(fetchAwaitingStoreStocktakingItems(result));
};

export const thunkFetchAwaitingStoreStocktakingCounts = () => async (
  dispatch: any
) => {
  const result = await StocktakingApi.getAwaitingCounts();

  if (!isOk(result)) {
    console.error(result.details);
  }

  dispatch(fetchAwaitingStoreStocktakingCounts(result));
};
